import React from 'react';
import { useParams } from 'react-router-dom';

import NoMoneyIcon from 'assets/NoMoneyIcon';
import Button, { ButtonVariant } from 'components/Button/Button';
import Icon, { IconVariant } from 'components/Icon/Icon';
import Panel from 'components/Panel/Panel';
import useGetAssessmentDetails from 'hooks/useGetAssessmentDetails';
import { t } from 'locales/i18n';

const NoPaymentInfo = () => {
  const { interviewUid } = useParams();
  const { data: interview } = useGetAssessmentDetails(interviewUid ?? '');
  return (
    <Panel panelClassName="mt-6">
      <div className="py-2 text-center">
        <div className="flex justify-center">
          <Icon
            icon={
              <NoMoneyIcon
                wrapperClassName="w-10 h-10"
                pathClassName="fill-kira-violet-900"
              />
            }
            variant={IconVariant.LARGE}
          />
        </div>
        <h4 className="prose-title-h4 mt-4">{t('No payment setup')}</h4>
        <p className="prose-title-input mt-2">
          {t('Contact our Client Success team to set up Applicant Pay.')}
        </p>
        <div className="mt-4 flex justify-center space-x-2">
          <a
            href={`mailto:success@kiratalent.com?subject=Request to enable Payment Requirement for ${interview?.name}`}
          >
            <Button
              variant={ButtonVariant.PRIMARY}
              type="button"
              buttonText={t('Contact Kira')}
            />
          </a>
          <a
            href="https://blog.kiratalent.com/get-started-with-holistic-admissions-applicant-pay/"
            target="_blank"
            rel="noreferrer"
          >
            <Button
              variant={ButtonVariant.SECONDARY}
              type="button"
              buttonText={t('Learn More')}
            />
          </a>
        </div>
      </div>
    </Panel>
  );
};

export default NoPaymentInfo;
